import {dynamic} from '@github-ui/dynamic'

import {useDeferredPayloadSlice} from '../utils/DeferredNavPayloadContext'

export function LazyAccountSwitchDialog() {
  const {data: accountSwitchDialogProps} = useDeferredPayloadSlice('account_switch_dialog')

  if (!accountSwitchDialogProps) {
    return null
  }

  return <AccountSwitchDialog {...accountSwitchDialogProps} />
}

const AccountSwitchDialog = dynamic(
  async () => {
    const mod = await import('../user-menu/AccountSwitchDialog')
    return {default: mod.AccountSwitchDialog}
  },
  {ssr: false},
)
